import axios from 'axios';
import * as Sentry from '@sentry/react';

const axiosInstanceNoAuth = axios.create({
  baseURL: import.meta.env.VITE_API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

axiosInstanceNoAuth.interceptors.request.use((config) => {
  // Add client IP to all requests
  const clientIP = localStorage.getItem('client_ip');
  if (clientIP) {
    config.headers['x-client-ip'] = clientIP;
  }
  return config;
});

axiosInstanceNoAuth.interceptors.response.use(
  (response) => response,
  (error) => {
    // Capture API errors with rich context
    Sentry.withScope((scope) => {
      // Add request context
      scope.setTag('request_url', error.config?.url || 'unknown');
      scope.setTag('request_method', error.config?.method || 'unknown');

      // Add response context
      const status = error?.response?.status;
      scope.setTag('response_status', status);

      // Add browser/device context
      scope.setContext('browser_info', {
        userAgent: navigator.userAgent,
        language: navigator.language,
        screenSize: `${window.screen.width}x${window.screen.height}`,
        viewportSize: `${window.innerWidth}x${window.innerHeight}`,
        connection: navigator.connection ? navigator.connection.effectiveType : 'unknown',
      });

      // Set appropriate error category
      scope.setTag('error_type', 'auth_api_error');

      // Custom fingerprinting based on error type
      const url = error.config?.url || '';
      const endpoint = url.split('/').slice(-2).join('/');

      // Group API errors by endpoint and status
      scope.setFingerprint(['auth-api-error', `endpoint-${endpoint}`, `status-${status}`]);

      // Capture the exception with enhanced context
      Sentry.captureException(error);
    });

    return Promise.reject(error.response);
  },
);

export default axiosInstanceNoAuth;
